module.exports = __webpack_public_path__ + "img/rtv_logo_WH_3840x2160px.c3ba87ab.png";